import styles from '../../features/formAfterSignUp/FormAfterSignUp.module.css';

export default function ConfirmEmailModal({
  email,
  handleProceed,
  onClose,
  isOpen,
  hasTypo,
  setEmail,
}: {
  email: string;
  handleProceed: () => void;
  onClose: () => void;
  isOpen: boolean;
  hasTypo: any;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
}) {
  return isOpen ? (
    <>
      <div className='fixed inset-0 z-[50000] overflow-y-auto'>
        <div className='fixed inset-0 w-full h-full bg-black opacity-40'></div>
        <div className='flex items-center min-h-screen px-6 py-4'>
          <div className='relative p-[2.6em] sm:py-[64px] sm:px-[64px] mx-auto bg-white rounded-md shadow-lg'>
            <div className='sm:mt-[1.5em] max-w-[300px] md:max-w-[400px] sm:flex justify-center'>
              <div className=' text-center sm:text-left font-[Poppins]'>
                <div className='text-[#229698] font-bold text-[18px] font-["Poppins"] leading-[30px]'>
                  Confirm email address
                </div>
                {hasTypo ? (
                  <div className='text-[14px] leading-[21px] text-[#212121] mt-2 mb-6 font-[Poppins]'>
                    Detected mistake in email, Did you mean{' '}
                    <span className='font-[700]'>{hasTypo?.correctedEmail}</span>?
                  </div>
                ) : (
                  <div className='text-[14px] leading-[21px] text-[#212121] mt-2 mb-6 font-[Poppins]'>
                    Please confirm that your email address{' '}
                    <span className='font-[700]'>{email}</span> is correct.
                  </div>
                )}
                <div className='items-center justify-between gap-2 mt-3 flex'>
                  {!hasTypo && (
                    <button
                      onClick={() => {
                        handleProceed();
                        onClose();
                      }}
                      className={[
                        styles.bgColor,
                        'p-2 flex-1 text-white outline-none rounded-[6px] h-[40px]',
                      ].join(' ')}
                    >
                      {`Proceed`}
                    </button>
                  )}
                  <button
                    onClick={() => {
                      if (hasTypo) {
                        setEmail(hasTypo?.correctedEmail);
                      }
                      onClose();
                    }}
                    className={[
                      styles.redColor,
                      'p-2 flex-1 text-white outline-none rounded-[6px] h-[40px]',
                    ].join(' ')}
                  >
                    {`Update email`}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
}
